import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CustomReportConfigData} from "./custom-report-config.data";

@Injectable()
export class CustomReportConfigEntityModel extends EntityModel<CustomReportConfigData> {
    constructor(injector: Injector) {
        super(injector, CustomReportConfigData);
    }
}
